import { default as Head } from "next/head";
import React, { ReactElement } from "react";
import { IReport } from "~/types/types";

interface IReportHeadProps {
  report: Pick<IReport, "title" | "description" | "images">;
}

const INNOVATORS_LOGO = "https://cdn.filestackcontent.com/I79rnaTR6A9I7IpQUdRw";

export default function ReportHead({ report }: IReportHeadProps): ReactElement {
  return (
    <Head>
      <title>{report.title}</title>

      <meta name="twitter:title" content={report.title || ""} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@Govlaunch" />
      <meta name="twitter:description" content={report.description || ""} />
      <meta
        name="twitter:image"
        content={(report.images || []).length > 0 ? (report.images as string[])[0] : INNOVATORS_LOGO}
      />
      <meta property="og:title" content={report.title || ""} />
      <meta property="og:description" content={report.description || ""} />
      <meta
        name="og:image"
        content={(report.images || []).length > 0 ? (report.images as string[])[0] : INNOVATORS_LOGO}
      />
    </Head>
  );
}
